import firebase from 'firebase';

const envData = window.SERVER_DATA;

const config = {
  apiKey: envData.FIREBASE_API_KEY,
  authDomain: envData.FIREBASE_AUTH_DOMAIN,
  databaseURL: envData.FIREBASE_DATABASE_URL,
  projectId: envData.FIREBASE_PROJECT_ID,
  storageBucket: envData.FIREBASE_STORAGE_BUCKET,
  messagingSenderId: envData.FIREBASE_MESSAGING_SENDER_ID,
  appId: envData.FIREBASE_APP_ID,
};

firebase.initializeApp(config);

export default firebase;
